import { z } from "zod";

export namespace Scope {
  export const schema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("personal"), userId: z.string().min(1) }),
    z.object({ kind: z.literal("space"), spaceId: z.string().min(1) }),
  ]);

  export type Info = z.infer<typeof schema>;

  export function personal(userId: string): Info {
    return { kind: "personal", userId };
  }

  export function space(spaceId: string): Info {
    return { kind: "space", spaceId };
  }

  export function id(scope: Info): string {
    return scope.kind === "personal" ? scope.userId : scope.spaceId;
  }

  export function fromId({ scopeId, userId }: { scopeId: string; userId: string }): Info {
    return scopeId === userId ? personal(userId) : space(scopeId);
  }

  export function isAccessible(scope: Info, spaces: readonly { id: string }[]): boolean {
    return scope.kind === "personal" || spaces.some((space) => space.id === scope.spaceId);
  }

  export function resolveAccessible(
    scope: Info,
    spaces: readonly { id: string }[],
    userId: string,
  ): Info {
    return isAccessible(scope, spaces) ? scope : personal(userId);
  }
}
